































import { Component, InjectReactive, Prop, Vue } from "vue-property-decorator";

import Simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";

import { dateFormat } from "@/utils/setFormatDate";
import DatePicker from "@/components/List/DatePicker/DatePicker.vue";
import ListBody from "@/components/List/ListBody.vue";
import { DataItem, DataWeeks } from "@/data.model";

@Component({
  components: {
    Simplebar,
    DatePicker,
    ListBody
  }
})
export default class ListView extends Vue {
  @InjectReactive() readonly pIsMobile!: boolean;
  @InjectReactive() readonly pSelectedDate!: Date;

  @Prop() readonly items!: DataItem[];
  @Prop() readonly weeks!: DataWeeks;

  isOpenCalendar = false;

  get filteredItems(): DataItem[] {
    const date = dateFormat.YYYY_MM_DD(this.pSelectedDate);
    return this.items.filter(
      item => dateFormat.YYYY_MM_DD(new Date(item.date)) === date
    );
  }

  get selectedDate() {
    return dateFormat.D_DDDD(this.pSelectedDate);
  }

  changeCalendarVisibility(value: boolean) {
    this.isOpenCalendar = value;
  }
}
